import script from "./RfidFoldingTicketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidFoldingTicketPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidFoldingTicketPage.vue?vue&type=style&index=0&id=46152c21&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46152c21"]])

export default __exports__